import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

const VISITOR_KEY = "ccl_visitor_id";

function visitorHash(): string | null {
  if (typeof window === "undefined") return null;
  try {
    let id = window.localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = crypto.randomUUID().replace(/-/g, "");
      window.localStorage.setItem(VISITOR_KEY, id);
    }
    return id.slice(0, 64);
  } catch {
    return null;
  }
}

function deviceType(): string {
  if (typeof window === "undefined") return "unknown";
  const w = window.innerWidth;
  if (w < 640) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

/**
 * Records an anonymous page view. Fire-and-forget: analytics must never
 * break a page render, so every failure is swallowed.
 */
export function recordPageView(path: string) {
  if (typeof window === "undefined") return;
  if (path.startsWith("/admin") || path.startsWith("/display")) return;

  const referrer =
    document.referrer && !document.referrer.includes(window.location.host)
      ? document.referrer.slice(0, 300)
      : null;

  void supabase
    .from("page_views")
    .insert({
      path: path.slice(0, 300),
      referrer,
      device: deviceType(),
      visitor_hash: visitorHash(),
    })
    .then(() => undefined, () => undefined);
}

/** Records a view whenever the pathname changes. */
export function usePageViewTracking(pathname: string) {
  useEffect(() => {
    recordPageView(pathname);
  }, [pathname]);
}
